import React, { Component } from 'react'
import shortid from "shortid";
import MyComponent from '../components/MyComponent';
export class OneColumnPage extends Component {
    render() {
        var state = this.props.state;
       var contentId = state.contentId
        var pagewidth = state.attributes.width
        const stylesObj = {
            width: pagewidth
        };
        return (
            <>
                <div className="containerWarp" data-cont-id={contentId ? contentId : ""} data-zone="HeaderContent" >
                    <div className="primary-zone" data-zone="HeaderContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="HeaderContent" >
                            {/* added new class for vastproSite padding issue (vastpro-p-0) */}
                            <div className="content row  container-fluid justify-content-around gx-0 p-0 mobile-width-style" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="HeaderContent">
                                {/* <NavbarHeader/>                    */}
                                {state.contents.HeaderContent.map(content => {
                                    let headerContentType = content['@type'];
                                    return (
                                        <MyComponent type={headerContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="HeaderContent" templateName={headerContentType} />
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* <MyComponent type={"HeaderContainer"} state={state} key={shortid.generate()} />   */}

                <div className="containerWarp" data-cont-id={contentId ? contentId : ""} data-zone="MainContent" >
                    <div className="primary-zone" data-zone="MainContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="MainContent" >
                            {/* added new class for vastproSite padding issue (vastpro-p-0) */}

                            <div className="content row container-fluid  justify-content-around gx-0 p-0  mobile-width-style ose-box-shadow-main" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="MainContent">
                                {state.contents.MainContent.map(content => {
                                    let contentType = content['@type'];
                                    return (
                                        <MyComponent type={contentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="MainContent" templateName={contentType} />
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <MyComponent type={"FooterContainer"} state={state} key={shortid.generate()} />   */}

                <div className="containerWarp" data-cont-id={contentId ? contentId : ""} data-zone="FooterContent" >
                    <div className="primary-zone" data-zone="FooterContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="FooterContent" >
                            {/* added new class for vastproSite padding issue (vastpro-p-0) */}
                            <div className="content row container-fluid justify-content-around gx-0 p-0 mobile-width-style ose-box-shadow-footer" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="FooterContent">
                                {/* <NavbarHeader/>                    */}
                                {state.contents.FooterContent.map(content => {
                                    let FooterContentType = content['@type'];
                                   return (
                                        <MyComponent type={FooterContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="FooterContent" templateName={FooterContentType} />
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default (OneColumnPage);